var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPlayButton = function SvgPlayButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 13.268c1.333.77 1.333 2.694 0 3.464L3 28.856c-1.333.77-3-.192-3-1.732V2.876C0 1.336 1.667.374 3 1.144l21 12.124z",
    fill: "#F05"
  })));
};
export default SvgPlayButton;